import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { List, X, WhatsappLogo } from "@phosphor-icons/react";
import { whatsappLink } from "../lib/data";
import logo from "../assets/logo.png";

const links = [
  { to: "/", label: "Home" },
  { to: "/servizi", label: "Servizi" },
  { to: "/chi-siamo", label: "Chi Siamo" },
  { to: "/contatti", label: "Contatti" },
];

export function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const loc = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => setOpen(false), [loc.pathname]);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled ? "bg-background/70 backdrop-blur-xl border-b border-border/40 py-3" : "py-6"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 flex items-center justify-between">
        <Link to="/" data-testid="logo-link" className="flex items-center">
          <img src={logo} alt="Cleansof" className={`w-auto transition-all duration-500 ${scrolled ? "h-9" : "h-11"}`} />
        </Link>

        <nav className="hidden md:flex items-center gap-9">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-${l.label.toLowerCase().replace(" ", "-")}`}
              className={({ isActive }) =>
                `text-sm tracking-wide transition-colors hover:text-primary ${
                  isActive ? "text-primary font-medium" : "text-muted-foreground"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <a
            href={whatsappLink()}
            target="_blank"
            rel="noreferrer"
            data-testid="header-whatsapp-btn"
            className="inline-flex items-center gap-2 rounded-full bg-primary text-primary-foreground px-5 py-2.5 text-sm hover:bg-primary/90 transition-colors active:scale-95"
          >
            <WhatsappLogo size={18} weight="fill" /> Preventivo
          </a>
        </nav>

        <button
          data-testid="mobile-menu-toggle"
          className="md:hidden text-primary"
          onClick={() => setOpen((o) => !o)}
        >
          {open ? <X size={26} /> : <List size={26} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-background/95 backdrop-blur-xl border-t border-border/40 mt-3">
          <div className="px-6 py-6 flex flex-col gap-5">
            {links.map((l) => (
              <NavLink key={l.to} to={l.to} className="text-lg text-primary">
                {l.label}
              </NavLink>
            ))}
            <a href={whatsappLink()} target="_blank" rel="noreferrer"
               className="inline-flex items-center gap-2 rounded-full bg-primary text-primary-foreground px-5 py-3 text-sm w-fit">
              <WhatsappLogo size={18} weight="fill" /> Richiedi preventivo
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
